import { FileTexture } from '@/types/api/Utility/FileTexture';
import { File } from '@/types/api/Utility/File';

/* eslint-disable @typescript-eslint/no-explicit-any*/
export class Video {
  public constructor() {
    //constructor
  }

  protected _fileId: number | null = null;
  protected _name: string | null = null;
  protected _type: string | null = null;
  protected _content: string | null = null;
  protected _textures: FileTexture[] | null = null;
  protected _thumbnailName: string | null = null;
  protected _thumbnailType: string | null = null;
  protected _thumbnailContent: string | null = null;
  protected _thumbnailTextures: FileTexture[] | null = null;

  /**
   * @returns _fileId
   */
  public get fileId() {
    return this._fileId;
  }

  /**
   * Sets _fileId
   */
  public set fileId(value: number | null) {
    this._fileId = value;
  }

  /**
   * @returns _name
   */
  public get name() {
    return this._name;
  }

  /**
   * Sets _name
   */
  public set name(value: string | null) {
    this._name = value;
  }

  /**
   * @returns _type
   */
  public get type() {
    return this._type;
  }

  /**
   * Sets _type
   */
  public set type(value: string | null) {
    this._type = value;
  }

  /**
   * base64 encoded file content
   * @returns _content
   */
  public get content() {
    return this._content;
  }

  /**
   * base64 encoded file content
   * Sets _content
   */
  public set content(value: string | null) {
    this._content = value;
  }

  /**
   * @returns _name
   */
  public get thumbnailName() {
    return this._thumbnailName;
  }

  /**
   * Sets _name
   */
  public set thumbnailName(value: string | null) {
    this._thumbnailName = value;
  }

  /**
   * @returns _type
   */
  public get thumbnailType() {
    return this._thumbnailType;
  }

  /**
   * Sets _type
   */
  public set thumbnailType(value: string | null) {
    this._thumbnailType = value;
  }

  /**
   * base64 encoded file content
   * @returns _content
   */
  public get thumbnailContent() {
    return this._thumbnailContent;
  }

  /**
   * base64 encoded file content
   * Sets _content
   */
  public set thumbnailContent(value: string | null) {
    this._thumbnailContent = value;
  }

  /**
   * @returns _textures
   */
  public get textures() {
    return this._textures;
  }

  /**
   * Sets _textures
   */
  public set textures(value: FileTexture[] | null) {
    this._textures = value;
  }

  /**
   * Specialized add method for bidirectional ManyToOne property textures _textures
   */
  public addTextures(value: FileTexture): void {
    if (value === null) {
      return;
    }
    if (this._textures?.includes(value)) {
      return;
    }
    this._textures?.push(value);
  }

  /**
   * Specialized add method for bidirectional ManyToOne property textures _textures
   */
  public addAllTextures(values: FileTexture[]): void {
    values.forEach((item) => {
      this.addTextures(item);
    });
  }

  /**
   * Specialized remove method for bidirectional ManyToOne property textures _textures
   */
  public removeTextures(value: FileTexture): void {
    if (value === null) {
      return;
    }
    if (!this._textures?.includes(value)) {
      return;
    }
    this._textures = this._textures.filter((x) => x !== value);
    value.file = new File();
  }

  /**
   * Specialized remove method for bidirectional ManyToOne property textures _textures
   */
  public removeAllTextures(values: FileTexture[]): void {
    values.forEach((item) => {
      this.removeTextures(item);
    });
  }

  /**
   * @returns _thumbnailTextures
   */
  public get thumbnailTextures(): FileTexture[] | null {
    return this._thumbnailTextures;
  }

  /**
   * Sets _thumbnailTextures
   */
  public set thumbnailTextures(value: FileTexture[] | null) {
    this._thumbnailTextures = value;
  }
  /**
   * Specialized add method for bidirectional ManyToOne property thumbnail_textures _thumbnailTextures
   */
  public addThumbnailTextures(value: FileTexture): void {
    if (value === null) {
      return;
    }
    if (this._thumbnailTextures?.includes(value)) {
      return;
    }
    this._thumbnailTextures?.push(value);
  }

  /**
   * Specialized add method for bidirectional ManyToOne property thumbnail_textures _thumbnailTextures
   */
  public addAllThumbnailTextures(values: FileTexture[]): void {
    values.forEach((item) => {
      this.addThumbnailTextures(item);
    });
  }

  /**
   * Specialized remove method for bidirectional ManyToOne property thumbnail_textures _thumbnailTextures
   */
  public removeThumbnailTextures(value: FileTexture): void {
    if (value === null) {
      return;
    }
    if (!this._thumbnailTextures?.includes(value)) {
      return;
    }
    this._thumbnailTextures = this._thumbnailTextures.filter((x) => x !== value);
    value.thumbnail = new File();
  }

  // Start Userdefined content - don't change anything above

  public deepCopy(toCopy: Video): Video {
    if (!toCopy) return toCopy;

    return {
      fileId: toCopy.fileId,
      name: toCopy.name,
      type: toCopy.type,
      content: toCopy.content,
      textures: [] as FileTexture[],
      thumbnailName: toCopy.thumbnailName,
      thumbnailType: toCopy.thumbnailType,
      thumbnailContent: toCopy.thumbnailContent,
      thumbnailTextures: [] as FileTexture[],
    } as Video;
  }

  public getServiceOutput(): any {
    return {
      fileId: this.fileId,
      name: this.name,
      type: this.type,
      content: this.content,
      textures: this.textures ?? [],
      thumbnailName: this.thumbnailName,
      thumbnailType: this.thumbnailType,
      thumbnailContent: this.thumbnailContent,
      thumbnailTextures: this.thumbnailTextures,
    };
  }

  // End Userdefined content - don't change anything below
}
